module.exports = __webpack_public_path__ + "static/images/step1.33838cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step/step1.png
// module id = MIuC
// module chunks = 1